import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { TransactionDetails } from '../modal';

export default function reducer(state: TransactionDetails = new TransactionDetails(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.TRANSACTION_DETAILS_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.TRANSACTION_DETAILS_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.TRANSACTION_DETAILS_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
